import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';

@Component({
  selector: 'ca-topic-inference-completed-notification',
  templateUrl: './topic-inference-completed-notification.component.html',
  styleUrls: ['./topic-inference-completed-notification.component.scss'],
  standalone: false,
})
@NotificationType(
  'TopicInferenceCompletedNotification',
  TopicInferenceCompletedNotificationComponent
)
export class TopicInferenceCompletedNotificationComponent implements OnInit {
  data: NotificationDto;

  constructor() {}

  ngOnInit(): void {}

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService
  ) {
    let message = localizationService.instant('AITopic::InferenceCompletedNotificationMessage');
    toastr.success(message);
  }
}
